import { z } from 'zod';
import { IdSchema, DateTimeSchema, PaginationParamsSchema } from '../../common';
export const AttendanceStatusSchema = z.enum(['present', 'absent', 'late', 'excused']);
export const AttendanceRecordSchema = z.object({
    id: IdSchema,
    courseId: IdSchema,
    studentUserId: IdSchema,
    sessionId: IdSchema.nullable(),
    sessionDate: DateTimeSchema,
    status: AttendanceStatusSchema,
    note: z.string().nullable(),
    recordedById: IdSchema.nullable(),
    createdAt: DateTimeSchema,
    updatedAt: DateTimeSchema,
    studentName: z.string().nullable().optional(),
    courseName: z.string().nullable().optional(),
});
export const MarkAttendanceEntrySchema = z.object({
    studentUserId: IdSchema,
    status: AttendanceStatusSchema,
    note: z.string().max(500).optional(),
});
export const MarkAttendanceSchema = z.object({
    courseId: IdSchema,
    sessionDate: z.string().datetime(),
    sessionId: IdSchema.optional(),
    entries: z.array(MarkAttendanceEntrySchema).min(1),
});
export const AttendanceQuerySchema = PaginationParamsSchema.extend({
    // Düzeltme 5 · D5-6 — yoklama matrisi bir dersin TÜM öğrenci×oturum kayıtlarını
    // ister (20 öğrenci × 8 oturum > 100). Genel 100'lük sayfa tavanı admin'in
    // limit:500 isteğini 400 ile reddediyordu → kaydedilen yoklama listede
    // görünmüyordu (list refetch sessizce düşüyordu). Tavanı yükselt.
    limit: z.coerce.number().int().min(1).max(2000).optional(),
    courseId: IdSchema.optional(),
    studentUserId: IdSchema.optional(),
    status: AttendanceStatusSchema.optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
//# sourceMappingURL=attendance.js.map